import {FC, Fragment} from 'react';
import {Link} from 'react-router';

import {Conversionratio, Totalcustomers, Totaldeals, Totalrevenue, marketData} from '@/lib/template_stats/adminData';
import {CryptoStatistics, Cryptobitcoin, Cryptoetherium} from '@/lib/template_stats/cryptoStats';

const DistributorDashboard: FC = () => {
  return (
    <Fragment>
      <div className="page-header-breadcrumb my-[1.5rem] block items-center justify-between md:flex">
        <div>
          <p className="!mb-0 text-[1.125rem] font-semibold text-defaulttextcolor dark:text-defaulttextcolor/70">
            Welcome back, Json Taylor!
          </p>
          <p className="text-[0.813rem] font-normal text-[#8c9097] dark:text-white/50">
            Track your sales activity, leads and deals hereasdf.
          </p>
        </div>
        <div className="btn-list mt-2 md:mt-0">
          <button
            type="button"
            className="ti-btn btn-wave !me-[0.375rem] !ms-0 mb-0 !rounded-[0.35rem] bg-primary !px-[0.86rem] !py-[0.51rem] !text-[0.85rem] !font-medium text-white shadow-none"
          >
            <i className="ri-filter-3-fill inline-block"></i>Filters
          </button>
          <button
            type="button"
            className="ti-btn ti-btn-outline-secondary btn-wave !me-[0.375rem] !ms-0 mb-0 !rounded-[0.35rem] !px-[0.86rem] !py-[0.51rem] !text-[0.85rem] !font-medium shadow-none"
          >
            <i className="ri-upload-cloud-line inline-block"></i>Export
          </button>
        </div>
      </div>
      <div className="grid grid-cols-12 gap-x-6">
        <div className="col-span-12 xl:col-span-12 xxl:col-span-12">
          <div className="grid grid-cols-12 gap-x-6">
            <div className="col-span-12 xl:col-span-12 xxl:col-span-12">
              <div className="grid grid-cols-12 gap-x-6">
                <div className="col-span-12 xl:col-span-3 xxl:col-span-3">
                  <div className="box overflow-hidden">
                    <div className="box-body">
                      <div className="items-top flex justify-between">
                        <div>
                          <span className="inline-flex !h-[2.5rem] !w-[2.5rem] items-center justify-center !rounded-full bg-primary !text-[0.8rem] !leading-[2.5rem]">
                            <i className="ti ti-users text-[1rem] text-white"></i>
                          </span>
                        </div>
                        <div className="ms-4 flex-grow">
                          <div className="flex flex-wrap items-center justify-between">
                            <div>
                              <p className="mb-0 text-[0.813rem] text-[#8c9097] dark:text-white/50">Total Customers</p>
                              <h4 className="!mb-2 text-[1.5rem] font-semibold">1,02,890</h4>
                            </div>
                            <div id="crm-total-customers">
                              <Totalcustomers />
                            </div>
                          </div>
                          <div className="!mt-1 flex items-center justify-between">
                            <div>
                              <Link className="text-[0.813rem] text-primary" to="#">
                                View All<i className="ti ti-arrow-narrow-right ms-2 inline-block font-semibold"></i>
                              </Link>
                            </div>
                            <div className="text-end">
                              <p className="mb-0 text-[0.813rem] font-semibold text-success">+40%</p>
                              <p className="text-[0.6875rem] text-[#8c9097] opacity-[0.7] dark:text-white/50">
                                this month
                              </p>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                <div className="col-span-12 xl:col-span-3 xxl:col-span-3">
                  <div className="box overflow-hidden">
                    <div className="box-body">
                      <div className="items-top flex justify-between">
                        <div>
                          <span className="inline-flex !h-[2.5rem] !w-[2.5rem] items-center justify-center !rounded-full bg-secondary !text-[0.8rem] !leading-[2.5rem]">
                            <i className="ti ti-wallet text-[1rem] text-white"></i>
                          </span>
                        </div>
                        <div className="ms-4 flex-grow">
                          <div className="flex flex-wrap items-center justify-between">
                            <div>
                              <p className="mb-0 text-[0.813rem] text-[#8c9097] dark:text-white/50">Total Revenue</p>
                              <h4 className="!mb-2 text-[1.5rem] font-semibold">$56,562</h4>
                            </div>
                            <div id="crm-total-revenue">
                              <Totalrevenue />
                            </div>
                          </div>
                          <div className="mt-1 flex items-center justify-between">
                            <div>
                              <Link className="text-[0.813rem] text-secondary" to="#">
                                View All<i className="ti ti-arrow-narrow-right ms-2 inline-block font-semibold"></i>
                              </Link>
                            </div>
                            <div className="text-end">
                              <p className="mb-0 text-[0.813rem] font-semibold text-success">+25%</p>
                              <p className="text-[0.6875rem] text-[#8c9097] opacity-[0.7] dark:text-white/50">
                                this month
                              </p>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                <div className="col-span-12 xl:col-span-3 xxl:col-span-3">
                  <div className="box overflow-hidden">
                    <div className="box-body">
                      <div className="items-top flex justify-between">
                        <div>
                          <span className="inline-flex !h-[2.5rem] !w-[2.5rem] items-center justify-center !rounded-full bg-success !text-[0.8rem] !leading-[2.5rem]">
                            <i className="ti ti-wave-square text-[1rem] text-white"></i>
                          </span>
                        </div>
                        <div className="ms-4 flex-grow">
                          <div className="flex flex-wrap items-center justify-between">
                            <div>
                              <p className="mb-0 text-[0.813rem] text-[#8c9097] dark:text-white/50">Conversion Ratio</p>
                              <h4 className="!mb-2 text-[1.5rem] font-semibold">12.08%</h4>
                            </div>
                            <div id="crm-conversion-ratio">
                              <Conversionratio />
                            </div>
                          </div>
                          <div className="mt-1 flex items-center justify-between">
                            <div>
                              <Link className="text-[0.813rem] text-success" to="#">
                                View All<i className="ti ti-arrow-narrow-right ms-2 inline-block font-semibold"></i>
                              </Link>
                            </div>
                            <div className="text-end">
                              <p className="mb-0 text-[0.813rem] font-semibold text-danger">-12%</p>
                              <p className="text-[0.6875rem] text-[#8c9097] opacity-[0.7] dark:text-white/50">
                                this month
                              </p>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                <div className="col-span-12 xl:col-span-3 xxl:col-span-3">
                  <div className="box overflow-hidden">
                    <div className="box-body">
                      <div className="items-top flex justify-between">
                        <div>
                          <span className="inline-flex !h-[2.5rem] !w-[2.5rem] items-center justify-center !rounded-full bg-warning !text-[0.8rem] !leading-[2.5rem]">
                            <i className="ti ti-briefcase text-[1rem] text-white"></i>
                          </span>
                        </div>
                        <div className="ms-4 flex-grow">
                          <div className="flex flex-wrap items-center justify-between">
                            <div>
                              <p className="mb-0 text-[0.813rem] text-[#8c9097] dark:text-white/50">Total Deals</p>
                              <h4 className="!mb-2 text-[1.5rem] font-semibold">2,543</h4>
                            </div>
                            <div id="crm-total-deals">
                              <Totaldeals />
                            </div>
                          </div>
                          <div className="mt-1 flex items-center justify-between">
                            <div>
                              <Link className="text-[0.813rem] text-warning" to="#">
                                View All<i className="ti ti-arrow-narrow-right ms-2 inline-block font-semibold"></i>
                              </Link>
                            </div>
                            <div className="text-end">
                              <p className="mb-0 text-[0.813rem] font-semibold text-success">+19%</p>
                              <p className="text-[0.6875rem] text-[#8c9097] opacity-[0.7] dark:text-white/50">
                                this month
                              </p>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div className="col-span-12 xl:col-span-12 xxl:col-span-12">
        <div className="box">
          <div className="box-header flex-wrap justify-between">
            <div className="box-title">Product Name Statistics</div>
            <div className="inline-flex rounded-md shadow-sm" role="group" aria-label="Basic example">
              <button
                type="button"
                className="ti-btn-group ti-btn-primary-full !border-0 !px-3 !py-2 !text-xs text-white"
              >
                1D
              </button>
              <button type="button" className="ti-btn-group ti-btn-primary !border-0 !px-3 !py-2 !text-xs">
                1W
              </button>
              <button type="button" className="ti-btn-group ti-btn-primary !border-0 !px-3 !py-2 !text-xs">
                1M
              </button>
              <button type="button" className="ti-btn-group ti-btn-primary !border-0 !px-3 !py-2 !text-xs">
                3M
              </button>
              <button type="button" className="ti-btn-group ti-btn-primary !border-0 !px-3 !py-2 !text-xs">
                6M
              </button>
              <button
                type="button"
                className="ti-btn-group ti-btn-primary !rounded-s-none !border-0 !px-3 !py-2 !text-xs"
              >
                1Y
              </button>
            </div>
          </div>
          <div className="box-body !p-0">
            <div className="flex flex-wrap border-b border-dashed p-4 dark:border-defaultborder/10">
              <div className="me-3">
                <span className="avatar avatar-md avatar-rounded bg-light p-2">
                  {/* <img src={bitcoinreg}
                    alt="" /> */}
                </span>
              </div>
              <div className="flex flex-grow flex-wrap sm:justify-evenly">
                <div className="m-2 sm:m-0">
                  <span>Symbol</span>
                  <p className="mb-0 font-semibold">CA - LA</p>
                </div>
                <div className="m-2 sm:m-0">
                  <span>Price Benchmark</span>
                  <p className="mb-0 font-semibold">128.00%</p>
                </div>
                <div className="m-2 sm:m-0">
                  <span>Price (USD)</span>
                  <p className="mb-0 font-semibold text-success">$4,253.49</p>
                </div>
                <div className="m-2 sm:m-0">
                  <span>Change (24H)</span>
                  <p className="mb-0 font-semibold text-danger">-0.24%</p>
                </div>
                <div className="m-2 sm:m-0">
                  <span>Market Cap</span>
                  <p className="mb-0 font-semibold">$179.12B</p>
                </div>
              </div>
            </div>
            <div id="crypto" className="p-4">
              <CryptoStatistics />
            </div>
          </div>
        </div>
      </div>
      <div className="grid grid-cols-12 gap-x-6">
        <div className="xl:col-col-12 col-span-12">
          <div className="col-span-12 xl:col-span-12 xxl:col-span-12">
            <div className="box">
              <div className="box-header flex-wrap justify-between">
                <div className="box-title mb-2 sm:mb-0">Active Markets</div>
                <div className="inline-flex rounded-md shadow-sm" role="group" aria-label="Basic example">
                  <button
                    type="button"
                    className="ti-btn-group ti-btn-primary-full !border-0 !px-3 !py-2 !text-xs text-white"
                  >
                    1D
                  </button>
                  <button type="button" className="ti-btn-group ti-btn-primary !border-0 !px-3 !py-2 !text-xs">
                    1W
                  </button>
                  <button type="button" className="ti-btn-group ti-btn-primary !border-0 !px-3 !py-2 !text-xs">
                    1M
                  </button>
                  <button type="button" className="ti-btn-group ti-btn-primary !border-0 !px-3 !py-2 !text-xs">
                    3M
                  </button>
                  <button type="button" className="ti-btn-group ti-btn-primary !border-0 !px-3 !py-2 !text-xs">
                    6M
                  </button>
                  <button
                    type="button"
                    className="ti-btn-group ti-btn-primary !rounded-s-none !border-0 !px-3 !py-2 !text-xs"
                  >
                    1Y
                  </button>
                </div>
              </div>
              <div className="box-body">
                <div className="table-responsive">
                  <table className="table-hover table-bordered table min-w-full whitespace-nowrap">
                    <thead>
                      <tr>
                        <th scope="col" className="text-start">
                          ID
                        </th>
                        <th scope="col" className="text-start">
                          Name
                        </th>
                        <th scope="col" className="text-start">
                          Symbol
                        </th>
                        <th scope="col" className="text-start">
                          Sales
                        </th>
                        <th scope="col" className="text-start">
                          Market Cap
                        </th>
                        <th scope="col" className="text-start">
                          Price Graph
                        </th>
                        <th scope="col" className="text-start">
                          Volume
                        </th>
                        <th scope="col" className="text-start">
                          Price Change
                        </th>
                      </tr>
                    </thead>
                    <tbody>
                      {marketData.map(data => (
                        <tr
                          key={data.ID}
                          className="border border-solid border-inherit hover:bg-gray-100 dark:border-defaultborder/10 dark:hover:bg-light"
                        >
                          <td>{data.ID}</td>
                          <td>
                            <Link to={`${import.meta.env.BASE_URL}/admin/dashboard/${data.ID}`}>{data.Name}</Link>
                          </td>
                          <td>
                            <div className="flex items-center leading-none">{data.Symbol}</div>
                          </td>
                          <td>{data.Sales}</td>
                          <td>{data.MarketCap}</td>
                          <td>
                            <div id={`${data.Name.toLowerCase().replace(' ', '-')}-price-graph`}>
                              {data.Name === 'Los Angeles' ? <Cryptobitcoin /> : <Cryptoetherium />}
                            </div>
                          </td>
                          <td>{data.Volume}</td>
                          <td>
                            <span className={data.PriceChange.startsWith('-') ? 'text-danger' : 'text-success'}>
                              {data.PriceChange}{' '}
                              <i
                                className={
                                  data.PriceChange.startsWith('-')
                                    ? 'ti ti-arrow-big-down-lines ms-1'
                                    : 'ti ti-arrow-big-up-lines ms-1'
                                }
                              ></i>
                            </span>
                          </td>
                        </tr>
                      ))}
                    </tbody>
                  </table>
                </div>
              </div>
              <div className="box-footer">
                <div className="items-center sm:flex">
                  <div className="dark:text-defaulttextcolor/70">
                    Showing 6 Entries <i className="bi bi-arrow-right ms-2 font-semibold"></i>
                  </div>
                  <div className="ms-auto">
                    <nav aria-label="Page navigation" className="pagination-style-4">
                      <ul className="ti-pagination mb-0">
                        <li className="page-item disabled">
                          <Link className="page-link" to="#">
                            Prev
                          </Link>
                        </li>
                        <li className="page-item">
                          <Link className="page-link active" to="#">
                            1
                          </Link>
                        </li>
                        <li className="page-item">
                          <Link className="page-link" to="#">
                            2
                          </Link>
                        </li>
                        <li className="page-item">
                          <Link className="page-link !text-primary" to="#">
                            next
                          </Link>
                        </li>
                      </ul>
                    </nav>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div className="fixed inset-0 z-50 hidden bg-gray-900 bg-opacity-50 opacity-0 transition dark:bg-opacity-80"></div>
    </Fragment>
  );
};

export default DistributorDashboard;
